/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminProductDetailGroupSaleMarketplace
 */
export interface AdminProductDetailGroupSaleMarketplace {
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSaleMarketplace
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSaleMarketplace
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSaleMarketplace
     */
    link: string;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminProductDetailGroupSaleMarketplace
     */
    name: AdminMarketplaceType;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSaleMarketplace
     */
    price: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSaleMarketplace
     */
    updatedAt: string;
}



export function AdminProductDetailGroupSaleMarketplaceFromJSON(json: any): AdminProductDetailGroupSaleMarketplace {
    return AdminProductDetailGroupSaleMarketplaceFromJSONTyped(json, false);
}

export function AdminProductDetailGroupSaleMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductDetailGroupSaleMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'link': json['link'],
        'name': AdminMarketplaceTypeFromJSON(json['name']),
        'price': json['price'],
        'updatedAt': json['updatedAt'],
    };
}

export function AdminProductDetailGroupSaleMarketplaceToJSON(value?: AdminProductDetailGroupSaleMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'link': value.link,
        'name': AdminMarketplaceTypeToJSON(value.name),
        'price': value.price,
        'updatedAt': value.updatedAt,
    };
}

